import { useSyncExternalStore } from "react"

import eq from "lodash-es/eq"

import type { TEmptyCallback } from "@/shared/types/functions"

import { ECoachingChatConversationApiMode as EApiMode } from "../types"

let currentMode: EApiMode | null = null

const apiModeListeners = new Set<TEmptyCallback>()

const connectionStore = {
    get(): EApiMode | null {
        return currentMode
    },
    set(mode: EApiMode | null): void {
        if (eq(currentMode, mode)) return

        currentMode = mode

        apiModeListeners.forEach((listener: TEmptyCallback): void => listener())
    },
    subscribe(listener: TEmptyCallback): TEmptyCallback {
        apiModeListeners.add(listener)

        return (): void => void apiModeListeners.delete(listener)
    },
    getServerSnapshot(): EApiMode | null {
        return currentMode
    }
}

function useCoachingChatConversationApiMode(): EApiMode | null {
    return useSyncExternalStore(connectionStore.subscribe, connectionStore.get, connectionStore.getServerSnapshot)
}

const { set: setCoachingChatConversationApiMode } = connectionStore

export { setCoachingChatConversationApiMode }
export { useCoachingChatConversationApiMode }
